module.exports = __webpack_public_path__ + "img/sticker_8.101b4775.svg";